module.exports = __webpack_public_path__ + "img/1.347b3bad.jpg";